import { useAuth0 } from '@auth0/auth0-react';
import { useDispatch } from 'react-redux';
import { closeSession } from '@client';
import { clientUserSignInLinkByEmail, getBaseUrl } from '@shared';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectSession } from '@client';

export const useClientSignOut = () => {
  const { logout } = useAuth0();
  const dispatch = useDispatch();
  const session = useSelector(selectSession);
  const { auth0Session } = session;

  const clientSignInLink = clientUserSignInLinkByEmail(auth0Session?.clientUser?.email);
  return () => {
    logout({
      logoutParams: {
        returnTo: clientSignInLink,
      },
    });
  };
};

const removeTableFilters = (): void => {
  // Remove Search
  localStorage.removeItem('clientsSearchText');

  // Remove Filters
  const prefixes = ['columnVisibility:', 'sorting:'];

  Object.keys(localStorage)
    .filter(key => prefixes.some(prefix => key.startsWith(prefix)))
    .forEach(key => localStorage.removeItem(key));
};

export const useSignOut = () => {
  const { logout, user } = useAuth0();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { auth0Session } = useSelector(selectSession);
  const email = user?.email || auth0Session?.advisorUser?.email;
  return () => {
    removeTableFilters();
    dispatch(closeSession());
    logout({
      logoutParams: {
        returnTo: `${getBaseUrl()}?email_hint=${encodeURIComponent(email ?? '')}`,
      },
    });
    navigate('/');
  };
};
